jQuery( ".dol-show-hide-button" ).click(function() {
	jQuery(this).parent().find(".dol-filter-body").toggle();

	var buttonText = jQuery(this).text();

	if( buttonText.indexOf('Close') >= 0) {
		jQuery(this).parent().find(".dol-show-hide-button:contains('Close')").html("<i class='fa fa-filter' aria-hidden='true'></i> Open Filters");
	} else {
		jQuery(this).parent().find(".dol-show-hide-button:contains('Open')").html("<i class='fa fa-filter' aria-hidden='true'></i> Close Filters");
	}
});

jQuery( ".dol-filter select" ).change(function() {
	jQuery(this).closest(".dol-filter").find("select");

	var filtersSelected = 0;

    jQuery(this).closest(".dol-filter").find("select").each(function(){
    	if (jQuery(this).val() != "") {
    		filtersSelected += 1;
    	}
    });

	jQuery(this).closest(".dol-filter").find(".dol-filter-badge").html(filtersSelected);
});

jQuery(".dol-clear-filter-button").click(function() {
    jQuery(this).closest('.dol-filter').find("select").val("");
    jQuery(this).closest(".dol-filter").find(".dol-filter-badge").html("0");
});

jQuery(document).ready(function(){
	jQuery(".show-hide-filters").click(function(){
		jQuery(this).text(jQuery(this).text() == ' Close Filters' ? ' Open Filters' : ' Close Filters');
	});
});
